export const API_BASE_URL = (import.meta as any).env?.VITE_API_BASE_URL || 'http://localhost:5001'

// Helper function to build API URLs
export const buildApiUrl = (path: string): string => {
  // Remove leading slash if present
  const cleanPath = path.startsWith('/') ? path.slice(1) : path
  return `${API_BASE_URL}/${cleanPath}`
}

export const apiCall = async (endpoint: string, options: RequestInit = {}) => {
  let url = buildApiUrl(endpoint)
  
  try {
    // Get JWT token from localStorage
    const token = localStorage.getItem('token')
    
    const response = await fetch(url, {
      ...options,
      mode: 'cors',
      credentials: 'include', // Include cookies for authentication
      headers: {
        'Content-Type': 'application/json',
        ...(token && { 'Authorization': `Bearer ${token}` }), // Add JWT token if available
        ...options.headers,
      },
    })
    
    return response
  } catch (error) {
    console.error(`API call failed for ${url}:`, error)
    
    // Enhanced error reporting for debugging SSL issues
    if ((import.meta as any).env.PROD && error instanceof TypeError) {
      console.error('This might be an SSL/HTTPS configuration issue. Check:')
      console.error('1. SSL certificate is valid and installed')
      console.error('2. Nginx is running and configured properly')
      console.error('3. AWS Security Group allows ports 80/443')
      console.error('4. Backend is running on port 5001')
    }
    
    throw error
  }
} 